import { render, staticRenderFns } from "./mian.vue?vue&type=template&id=31cefe4e&scoped=true&"
import script from "./mian.vue?vue&type=script&lang=ts&"
export * from "./mian.vue?vue&type=script&lang=ts&"
import style0 from "./mian.vue?vue&type=style&index=0&id=31cefe4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cefe4e",
  null
  
)

export default component.exports